import * as PropTypes from 'prop-types';
import * as React from 'react';
import ShippingLabelEditAddressForm from './edit_address_form';
import ShippingLabelHiddenAddressForm from './hidden_address_form';
import ShippingLabelStaticAddress from './static_address';

class ShippingLabelAddressBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.name || '',
      streetAddress: props.streetAddress || '',
      extendedAddress: props.extendedAddress || '',
      locality: props.locality || '',
      region: props.region || '',
      postalCode: props.postalCode || '',
      countryCode: props.countryCode || '',
      phone: props.phone || '',
      isEditing: props.isEditing,
      hasVerificationErrors: props.hasVerificationErrors,
    };
  }

  toggleEditing() {
    this.setState({ isEditing: !this.state.isEditing });
  }

  editAddressButton() {
    if (!this.props.isEditable) { return null; }
    if (this.isEditing()) { return null; }

    return (
      <a
        className="button button--mini button--blue pull-right"
        onClick={() => this.toggleEditing()}
      >
        {I18n.t('js.dashboard.selling.shippingLabels.edit')}
      </a>
    );
  }

  updateAddress(properties) {
    this.setState({
      name: properties.name,
      streetAddress: properties.streetAddress,
      extendedAddress: properties.extendedAddress,
      locality: properties.locality,
      region: properties.region,
      postalCode: properties.postalCode,
      countryCode: properties.countryCode,
      phone: properties.phone,
      isEditing: false,
      hasVerificationErrors: false,
    });
  }

  nameForInput(fieldName) {
    const formPrefixBase = 'shipping_label_form';
    return `${formPrefixBase}[${this.props.formPrefix}][${fieldName}]`;
  }

  editAddressForm() {
    return (
      <ShippingLabelEditAddressForm
        name={this.state.name}
        streetAddress={this.state.streetAddress}
        extendedAddress={this.state.extendedAddress}
        locality={this.state.locality}
        region={this.state.region}
        postalCode={this.state.postalCode}
        countryCode={this.state.countryCode}
        phone={this.state.phone}
        nameForInput={fieldName => this.nameForInput(fieldName)}
        includePhoneInput={this.props.includePhoneInput}
        phoneInputRequired={this.props.phoneInputRequired}
      />
    );
  }

  hiddenAddressForm() {
    return (
      <ShippingLabelHiddenAddressForm
        name={this.state.name}
        streetAddress={this.state.streetAddress}
        extendedAddress={this.state.extendedAddress}
        locality={this.state.locality}
        region={this.state.region}
        postalCode={this.state.postalCode}
        countryCode={this.state.countryCode}
        phone={this.state.phone}
        nameForInput={fieldName => this.nameForInput(fieldName)}
        includePhoneInput={this.props.includePhoneInput}
      />
    );
  }

  isEditing() {
    return !!(this.state.isEditing || this.state.hasVerificationErrors);
  }

  addressSection() {
    if (this.isEditing()) { return this.editAddressForm(); }

    return (
      <div>
        <ShippingLabelStaticAddress
          name={this.state.name}
          streetAddress={this.state.streetAddress}
          extendedAddress={this.state.extendedAddress}
          locality={this.state.locality}
          region={this.state.region}
          postalCode={this.state.postalCode}
          countryCode={this.state.countryCode}
          phone={this.state.phone}
        />
        {this.hiddenAddressForm()}
      </div>
    );
  }

  heading() {
    if (!this.props.heading) { return null; }
    return (
      <h3 className="heading-3 mb-half">{this.props.heading}</h3>
    );
  }

  render() {
    return (
      <div>
        {this.editAddressButton()}
        {this.heading()}
        {this.addressSection()}
      </div>
    );
  }
}

ShippingLabelAddressBox.propTypes = {
  name: PropTypes.string,
  streetAddress: PropTypes.string,
  extendedAddress: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
  isEditing: PropTypes.bool.isRequired,
  isEditable: PropTypes.bool,
  heading: PropTypes.string.isRequired,
  formPrefix: PropTypes.string.isRequired,
  includePhoneInput: PropTypes.bool.isRequired,
  phoneInputRequired: PropTypes.bool.isRequired,
  hasVerificationErrors: PropTypes.bool,
};

ShippingLabelAddressBox.defaultProps = {
  isEditable: true,
};

export default ShippingLabelAddressBox;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/address_box.jsx